import React from 'react'
import * as AppStore from './../state/app-store'
import { Button, Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import * as Selectors from './../state/selectors'
import { setMetric } from '../state/app-store'
import RadioButtonGroup from './RadioButtonGroup'

const useUnit = () => {
	const dispatch = AppStore.useAppDispatch()

	const setUnit = (unit: string | undefined): void => {
		if (unit) {
			dispatch(setMetric(unit))
		}
	}

	return { setUnit }
}

const BottomLeftUnits: React.FC = () => {
	const [opened, { open, close }] = useDisclosure(false)
	const { setUnit } = useUnit()

	const unit = AppStore.useAppSelector(Selectors.unitSelector)

	const unitOptions = [
		{ display: 'km + metres', value: 'metric' },
		{ display: 'miles + feet', value: 'imperial' },
	]

	return (
		<>
			<Modal opened={opened} onClose={close} title="Units" size="md">
				<p>
					Set the units you want to use and see displayed throughout the site.
				</p>
				<h4>Distances + heights</h4>
				<RadioButtonGroup<string>
					items={unitOptions}
					value={unit}
					onChange={(val) => setUnit(val)}
					nullable={false}
					size="sm"
				/>
			</Modal>

			<div className="bottom-corner-element left-corner">
				<Button.Group>
					<Button onClick={() => open()} variant="default" radius={0}>
						<span
							style={{
								fontWeight: unit === 'metric' ? 'bold' : 'normal',
							}}
						>
							km
						</span>
						&nbsp;&nbsp;/&nbsp;&nbsp;
						<span
							style={{
								fontWeight: unit === 'imperial' ? 'bold' : 'normal',
							}}
						>
							miles
						</span>
					</Button>
				</Button.Group>
			</div>
		</>
	)
}

export default BottomLeftUnits
